import React from 'react'

const SvgPlay = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="160"
    height="182"
    viewBox="0 0 160 182">
    <defs>
      <filter
        id="Polygon_5"
        x="0"
        y="0"
        width="160"
        height="182"
        filterUnits="userSpaceOnUse">
        <feOffset dy="9" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="6" result="blur" />
        <feFlood floodOpacity="0.161" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Polygon_5)">
      <path
        id="Polygon_5-2"
        data-name="Polygon 5"
        d="M59.212,23.421a16,16,0,0,1,27.576,0L131.8,99.883A16,16,0,0,1,118.014,124H27.986A16,16,0,0,1,14.2,99.883Z"
        transform="translate(142 9) rotate(90)"
        fill="#fff"
      />
    </g>
  </svg>
)

export default SvgPlay
